class MediaCarousel {
  constructor(section) {
    this.section = section;

    this.modal = document.getElementById('media-video-modal');
    this.player = document.getElementById('media-video-player');

    if (!this.modal || !this.player) return;

    this.overlay = this.modal.querySelector('.media-video-modal__overlay');
    this.closeButton = this.modal.querySelector('.media-video-modal__close');

    this.bindCards();
    this.bindModal();
  }

  getVideoId(url) {
    if (!url) return '';

    if (url.includes('youtu.be/')) {
      return url.split('youtu.be/')[1].split('?')[0];
    }

    if (url.includes('watch?v=')) {
      return url.split('v=')[1].split('&')[0];
    }

    if (url.includes('/shorts/')) {
      return url.split('/shorts/')[1].split('?')[0];
    }

    return '';
  }

bindCards() {

  this.section.querySelectorAll('.media-item, .featured-video').forEach((card) => {
    const play = () => {

      const url = card.dataset.mediaUrl;
      console.log('Clicked:', card);
      console.log('URL:', url);
      const id = this.getVideoId(url);
      console.log('Video ID:', id);
      if (!id) return;

      this.open(id);

    };

    card.addEventListener('click', play);

    card.addEventListener('keydown', (e) => {

      if (e.key === 'Enter' || e.key === ' ') {

        e.preventDefault();

        play();

      }

    });

  });

}

  bindModal() {

    this.overlay.addEventListener('click', () => this.close());

    this.closeButton.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {

      if (e.key === 'Escape') {

        this.close();

      }

    });

  }

  open(id) {

    this.player.innerHTML = `
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0"
        title="YouTube Video"
        frameborder="0"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowfullscreen>
      </iframe>
    `;

    this.modal.classList.add('is-open');

  }

  close() {

    this.modal.classList.remove('is-open');

    this.player.innerHTML = '';

  }

}

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll(
    '[id^="media-carousel-"], [id^="featured-videos-"]'
  ).forEach((section) => {

    new MediaCarousel(section);

  });

});